import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SvgIcon, Flex, ButtonOutlined as ButtonOutlinedBase, Text } from 'Components/Base';

const ButtonOutlined = styled(ButtonOutlinedBase)`
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
  padding: 12px 24px;
  border-radius: 300px;
  display: inline-flex;
  align-items: center;
  min-width: 148px;
  border: 2px solid;
`;

function SolutionFooter(/**@type {SolutionFooterProps}*/ props) {
  const {
    onClickBack,
    onClickNext,
    hideBack = false,
    hideNext = false,
    disabledBack = false,
    disabledNext = false,
    ...restProps
  } = props;
  return (
    <Flex
      bottom={0}
      padding={6}
      width={1}
      backgroundColor={'white'}
      justifyContent={'space-between'}
      style={{ boxShadow: '0 -2px 4px rgba(0, 0, 0, 0.1)' }}
      {...restProps}
    >
      <ButtonOutlined
        color={disabledBack ? 'textColor.disabled' : 'clear.clearDark'}
        onClick={onClickBack}
        hidden={hideBack}
        disabled={disabledBack}
      >
        <SvgIcon icon={SvgIcon.ICON_LIST.BACK} mr={1} size={24} />
        <Text textStyle={'body1Medium'}>{'ข้อก่อนหน้า'}</Text>
      </ButtonOutlined>
      <ButtonOutlined
        color={disabledNext ? 'textColor.disabled' : 'clear.clearDark'}
        onClick={onClickNext}
        hidden={hideNext}
        disabled={disabledNext}
        style={{ justifyContent: 'flex-end' }}
      >
        <Text textStyle={'body1Medium'}>{'ข้อถัดไป'}</Text>
        <SvgIcon icon={SvgIcon.ICON_LIST.ARROW_RIGHT} ml={1} size={24} />
      </ButtonOutlined>
    </Flex>
  );
}

SolutionFooter.propTypes = {
  onClickBack: PropTypes.func,
  onClickNext: PropTypes.func,
  disabledBack: PropTypes.bool,
  disabledNext: PropTypes.bool,
  hideBack: PropTypes.bool,
  hideNext: PropTypes.bool,
};

export default SolutionFooter;

/**
 * @typedef {Object} SolutionFooterProps
 * @property {Function} onClickBack
 * @property {Function} onClickNext
 * @property {boolean} hideBack
 * @property {boolean} hideNext
 * @property {boolean} disabledBack
 * @property {boolean} disabledNext
 */
